import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles/index';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper/index';
import Step from '@material-ui/core/Step/index';
import StepLabel from '@material-ui/core/StepLabel/index';
import Check from '@material-ui/icons/Check';
import StepConnector from '@material-ui/core/StepConnector/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';

/**
 * NextSteps component
 * @example
 *  <NextSteps
 *     steps: {
 *         1: {
 *             step: "step title a",
 *             icon: "fontawesome identifier"
 *         },
 *          2: {
 *             step: "step title b",
 *             icon: "fontawesome identifier"
 *         }
 *     }
 *     activeStep: number
 *     >
 *     { headingTitle }
 * </NextSteps>
 */

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#ffffff',
        display: 'flex',
        height: 22,
        alignItems: 'center'
    },
    active: {
        color: '#784af4'
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: '#ffffff'
    },
    completed: {
        color: '#ffffff',
        zIndex: 1,
        fontSize: 18
    }
});

const QontoStepIcon = props => {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={ clsx(classes.root, {
                [classes.active]: active
            }) }
        >
            { completed ? <Check className={ classes.completed } /> : <div className={ classes.circle } />}
        </div>
    );
};

QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool
};

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 37,
        margin: '0 .8rem',
        padding: '0 1rem'
    },
    active: {
        '& $line': {
            backgroundColor: '#E8F2F8',
            borderBottom: 'none'
        }
    },
    completed: {
        '& $line': {
            backgroundColor: '#ffffff',
            borderBottom: 'none'
        }
    },
    line: {
        height: 3,
        borderRadius: 1,
        borderBottom: '1px dashed #ffffff',
        borderTopStyle: 'none'
    }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#E8F2F8',
        zIndex: 1,
        color: '#63A9D0',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    active: {
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 10px 0 rgba(0, 0, 0, .25)'
    },
    completed: {
        color: '#63A9D0',
        backgroundColor: '#ffffff'
    }
});

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    button: {
        marginRight: theme.spacing(1)
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    icon: {
        color: '#00ff00'
    }
}));

const NextSteps = props => {
    const classes = props.classes ? props.classes : useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = [];
    const icons = {};

    // looping through steps prop to extract array of steps and object of icons
    for (const [k, v] of Object.entries(props.steps)) {
        steps.push(v.step);
        icons[k] = v.icon;
    }

    const ColorlibStepIcon = ColorlibStepIconProps => {
        const ColorlibStepIconClasses = useColorlibStepIconStyles();
        const { active, completed } = ColorlibStepIconProps;

        return (
            <div
                className={ clsx(ColorlibStepIconClasses.root, {
                    [ColorlibStepIconClasses.active]: active,
                    [ColorlibStepIconClasses.completed]: completed
                }) }
            >
                <p>{ completed ? <FontAwesomeIcon className={ classes.icon } icon={ 'check-circle' }/> : null }</p>
                { <FontAwesomeIcon icon={ icons[String(ColorlibStepIconProps.icon)] }/> }
            </div>
        );
    };

    ColorlibStepIcon.propTypes = {
        active: PropTypes.bool,
        completed: PropTypes.bool,
        icon: PropTypes.node
    };

    useEffect(() => {
        setActiveStep(props.activeStep);
    }, []);

    return (
        <div className={ classes.root }>
            { props.children }
            <Stepper alternativeLabel activeStep={ activeStep } connector={ <ColorlibConnector /> }>
                { steps.map(label => (
                    <Step key={ label } className={ classes.label }>
                        <StepLabel StepIconComponent={ ColorlibStepIcon }>{ label }</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
};

NextSteps.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    classes: PropTypes.shape({
        root: PropTypes.string
    })
};

export default NextSteps;
